import { Component } from '@angular/core';
import { ScoreWidgetComponent } from '../score-widget/score-widget.component';
import { NgStyle } from '@angular/common';
import { ScoreLineChartComponent } from '../score-line-chart/score-line-chart.component';
import { ScoreDrilldownTableNewComponent } from '../score-drilldown-table-new/score-drilldown-table-new.component';

@Component({
    selector: 'app-score-trends-new',
    templateUrl: './score-trends-new.component.html',
    styleUrl: './score-trends-new.component.scss',
    imports: [ScoreWidgetComponent, NgStyle, ScoreLineChartComponent, ScoreDrilldownTableNewComponent]
})

export class ScoreTrendsNewComponent {
  mainDiscription: string = 'Analyze the primary score, its components, and score distribution over time, with adjustable detail across multiple dimensions. Get a quick overview of the score and total responses for the selected period.';
  scoreTrendsDiscription: string= 'Track score trends with adjustable time views (daily, weekly, etc.), showing overall data or data for a selected row. Hover to view scores and distribution for specific time intervals.';
  scoreDiscription: string= 'Gain insights into the overall score and response breakdown across various dimensions. Click the launch icon to navigate, or select a row to filter the trend charts.';

  isFullScreen = false;

  lineChartPlugins: any = {
    lineColor: '#2CA02C',
    gradientStartColor: '#2CA02C',
    gradientEndColor: '#2CA02C0F',
    borderWidth: 2,
    pointBorderWidth: 2,
    pointRadius: 6,
    pointBorderColor: '#ffffff',
  };
  lineChartData: any = {
    labels: ["01 Jun '25", "02 Jun '25", "03 Jun '25", "04 Jun '25", "05 Jun '25", "06 Jun '25", "07 Jun '25", "08 Jun '25"],
    xText: 'Request Date (Start Date)',
    yText: 'NPS',
    data: [10, 15, 3, 5, 8, 9, 34, 12, 1, 67]
  };


  scoreWidget(type: string): any {
    return {
      isFullScreenButtonShow: true,
      isDownloadButtonShow: true,
      isTrendDropdownShow: type === 'lineChart' || type === 'barChart' ? true : false,
      isAbsoluteChartShow: type === 'barChart' ? true : false,
      isPercenttageChartShow: type === 'barChart' ? true : false,
    };
  }

  onFullScreen(event, cardName) {

  }

  onDownload(cardName) {

  }

  onTrendChange(event, cardName) {

  }

  onGraphDataPointClick(event, cardName, index) {

  }
}
